<template>
  <BaseLanding
    v-if="isDev"
    :filter="filter"
    :faq-id="11">
  </BaseLanding>
</template>

<script>
import BaseLanding from '@/components/BaseLanding.vue'
import { goToLanding } from '@/utils/goToLanding'

export default {
  name: 'Home',
  props: [
    'filter'
  ],
  data () {
    return {
      isDev: process.env.VUE_APP_IS_DEV
    }
  },
  components: {
    BaseLanding
  },
  created () {
    if (!this.isDev) {
      goToLanding()
    }
  }
}
</script>
